import { render } from "./RentSeekerShortlistPage.vue?vue&type=template&id=b8b00fc0&scoped=true"
import script from "./RentSeekerShortlistPage.vue?vue&type=script&lang=js"
export * from "./RentSeekerShortlistPage.vue?vue&type=script&lang=js"

import "./RentSeekerShortlistPage.vue?vue&type=style&index=0&id=b8b00fc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b00fc0"]])

export default __exports__